module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table"
  }, [_c('div', {
    staticClass: "table-actions"
  }, [_c('filters', {
    attrs: {
      "filters": _vm.filters
    },
    on: {
      "filter": _vm.filter
    }
  })], 1), _c('div', {
    staticClass: "table-header table-row"
  }, [_c('div', {
    staticClass: "table-col table-col-80"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v(_vm._s(_vm.$t('businesses.attributes.name')))])]), _c('div', {
    staticClass: "table-col table-col-80"
  }, [_vm._v(_vm._s(_vm.$t('businesses.attributes.address')))]), _c('div', {
    staticClass: "table-col table-col-60"
  }, [_vm._v(_vm._s(_vm.$t('businesses.attributes.status')))]), _c('div', {
    staticClass: "table-col table-col-60"
  }, [_vm._v(_vm._s(_vm.$t('businesses.attributes.stage')))]), _c('div', {
    staticClass: "table-col table-col-120"
  }, [_vm._v(_vm._s(_vm.$t('businesses.attributes.tags')))]), _c('div', {
    staticClass: "table-col table-col-120"
  }, [_vm._v(_vm._s(_vm.$t('businesses.attributes.contacts')))]), _c('div', {
    staticClass: "table-col table-col-collapsed"
  })]), _c('div', {
    staticClass: "table-body"
  }, _vm._l((_vm.businesses), function(business, business_id) {
    return _c('business-list-item', {
      attrs: {
        "business": business
      },
      on: {
        "business-destroy": _vm.openDestroyBusinessModal
      }
    })
  }), 1), _c('confirm-modal', {
    attrs: {
      "id": "confirm-remove-business",
      "title": _vm.$t('businesses.label.removeCompany'),
      "confirm_text": _vm.$t('general.actions.delete'),
      "message": _vm.$t('businesses.label.removeCompany', {
        name: _vm.selected_business.name
      }),
      "confirm_class": "btn-danger"
    },
    on: {
      "confirm-modal-confirm": _vm.callDestroyBusiness
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7d9d557a!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/businesses/list.vue
// module id = 1177
// module chunks = 1